/**
 * Vanturis brand logo.
 *
 * CANONICAL SOURCE: the OWNER-ATTACHED master
 *   /brand/vanturis-logo-master.webp  (SHA-256 8fd3e94e…; 2000x667 RGBA gold lockup)
 * Web derivatives (aspect ratio preserved, NOT recolored/redrawn/cropped):
 *   vanturis-logo-web@2x.png (576x192) — used for all on-screen variants.
 * The owner-attached artwork overrides all legacy repository logos
 * (master_*.svg / icon_*.svg are LEGACY and no longer referenced).
 * Do NOT redraw, recolor, crop, or substitute the master.
 */
const MASTER_GOLD = "/brand/vanturis-logo-web@2x.png?v=2026owner";
const MASTER_BLACK = "/brand/vanturis-logo-light-web@2x.png?v=2026light";
const MASTERS = {
  black: MASTER_BLACK,
  gold: MASTER_GOLD,
  white: MASTER_GOLD,
  iconBlack: MASTER_BLACK,
  iconGold: MASTER_GOLD,
  iconWhite: MASTER_GOLD,
};

export default function Logo({
  variant = "master-black",   // 'master-black' | 'master-gold' | 'master-white' | 'icon-black' | 'icon-gold' | 'icon-white'
  height = 40,                // px, prevents CLS
  className = "",
  ariaLabel = "Vanturis",
}) {
  const src = {
    "master-black": MASTERS.black,
    "master-gold": MASTERS.gold,
    "master-white": MASTERS.white,
    "icon-black": MASTERS.iconBlack,
    "icon-gold": MASTERS.iconGold,
    "icon-white": MASTERS.iconWhite,
  }[variant] || MASTERS.black;

  return (
    <img
      src={src}
      alt={ariaLabel}
      height={height}
      style={{ height: `${height}px`, width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
      data-testid="brand-logo"
    />
  );
}
